import { useTheme } from '../../hooks/useTheme'

/** Botão sol/lua no header — alterna entre tema claro e escuro (persistido).
 *  `onDark` estiliza para o chrome navy (fundo escuro constante). */
export default function ThemeToggle({ className = '', onDark = false }: { className?: string; onDark?: boolean }) {
  const { resolvedTheme, toggle } = useTheme()
  const isDark = resolvedTheme === 'dark'
  const tone = onDark
    ? 'bg-white/10 hover:bg-white/20 text-white/90'
    : 'bg-sunken hover:bg-line text-ink-muted hover:text-ink'
  return (
    <button
      type="button"
      onClick={toggle}
      title={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      className={`shrink-0 flex items-center justify-center w-8 h-8 rounded-lg ${tone} transition-colors touch-action-manip ${className}`}
    >
      <span aria-hidden className="text-base leading-none">{isDark ? '☀️' : '🌙'}</span>
    </button>
  )
}
